module.exports = __webpack_public_path__ + "resources/icon_94_gonglueadd.491c8190533cecb2.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_gonglueadd.png
// module id = 622
// module chunks = 0 1 2 3